// CYBORG-308: an unauthenticated visit to an authed-only workspace route
// (e.g. a shared page link) bounces to /login. Without carrying the intended
// destination, login always lands on /workspace after sign-in — the shared
// link is lost. login/+page.svelte already reads `?next=` (same-origin
// `startsWith("/")` guarded) for the invite flow; this builds that same query
// string for the workspace layout's redirects.
export function loginRedirectPath(pathname: string, search: string, now = Date.now()): string {
  const why =
    ended && now - ended.at < ENDED_TTL_MS ? `&ended=${encodeURIComponent(ended.reason)}` : "";
  return `/login?next=${encodeURIComponent(pathname + search)}${why}`;
}

// Why the session ended, chosen by the socket close (auth_expired). The workspace guard's own
// redirect fires right after it and wins the navigation, so it must carry the reason too (B13).
// ponytail: a 30 s window, not a consume-once, because the guard may redirect more than once.
const ENDED_TTL_MS = 30_000;
let ended: { reason: string; at: number } | undefined;
export function noteSessionEnded(reason: string, now = Date.now()): void {
  ended = { reason, at: now };
}
